import React, { useRef } from 'react';
import { Box, CircularProgress } from '@mui/material';
import ChevronLeftIcon  from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import T from '../theme';
import { MODULES } from '../config.jsx';

export function MobileModulePicker({ track, currentModule, onSelectModule, moduleLoading }) {
  const modules   = MODULES[track];
  const scrollRef = useRef(null);
  const scrollBy  = (dir) => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: dir * 160, behavior: 'smooth' });
  };

  return (
    <Box
      sx={{
        display: { xs: 'flex', md: 'none' },
        alignItems: 'center',
        background: T.sidebar,
        borderBottom: `1px solid ${T.border}`,
        flexShrink: 0,
      }}
    >
      <Box
        component="button"
        onClick={() => scrollBy(-1)}
        sx={{ flexShrink: 0, background: 'none', border: 'none', color: T.primary, cursor: 'pointer', px: 1, py: 0, display: 'flex', alignItems: 'center', fontSize: 0 }}
      >
        <ChevronLeftIcon sx={{ fontSize: 22 }} />
      </Box>

      <Box
        ref={scrollRef}
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 1,
          px: 1,
          py: 1.5,
          flex: 1,
          '&::-webkit-scrollbar': { display: 'none' },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
        }}
      >
        {modules.map((mod) => {
          const isActive  = currentModule === mod.id;
          const isLoading = moduleLoading[mod.id];
          return (
            <Box
              key={mod.id}
              component="button"
              onClick={() => onSelectModule(mod.id)}
              sx={{
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1.5,
                py: 0.75,
                background: isActive ? T.primary : T.surface2,
                border: `1px solid ${isActive ? T.primary : T.border}`,
                borderRadius: 5,
                color: isActive ? '#fff' : T.textSecondary,
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                transition: 'all 0.15s',
                '&:hover': isActive ? {} : { background: T.hover, color: T.text },
              }}
            >
              {isLoading
                ? <CircularProgress size={12} sx={{ color: isActive ? '#fff' : T.primary }} />
                : mod.icon
              }
              {mod.name}
            </Box>
          );
        })}
      </Box>

      <Box
        component="button"
        onClick={() => scrollBy(1)}
        sx={{ flexShrink: 0, background: 'none', border: 'none', color: T.primary, cursor: 'pointer', px: 1, py: 0, display: 'flex', alignItems: 'center', fontSize: 0 }}
      >
        <ChevronRightIcon sx={{ fontSize: 22 }} />
      </Box>
    </Box>
  );
}
